import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  color: ', ';\n  font-size: 14px;\n  font-weight: 500;\n  white-space: nowrap;\n'], ['\n  color: ', ';\n  font-size: 14px;\n  font-weight: 500;\n  white-space: nowrap;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  color: ', ';\n'], ['\n  color: ', ';\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  color: ', ';\n\n  @media (max-width: ', ') {\n    display: block;\n  }\n'], ['\n  color: ', ';\n\n  @media (max-width: ', ') {\n    display: block;\n  }\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  color: ', ';\n  padding-left: 4px;\n  text-decoration: line-through;\n'], ['\n  color: ', ';\n  padding-left: 4px;\n  text-decoration: line-through;\n']);

import styled from 'styled-components';

export var StyledPriceWrapper = styled.div(_templateObject, function (props) {
  return props.theme.dormifyBoulder;
});

export var StyledSalePrice = styled.span(_templateObject2, function (_ref) {
  var sale = _ref.sale,
      theme = _ref.theme;
  return sale ? theme.dormifyPink : theme.dormifyBoulder;
});

export var StyledSalePriceRange = styled.span(_templateObject3, function (_ref2) {
  var sale = _ref2.sale,
      theme = _ref2.theme;
  return sale ? theme.dormifyPink : theme.dormifyBoulder;
}, function (props) {
  return props.theme.mobileWidth;
});

export var StyledPriceCrossedOut = styled.span(_templateObject4, function (props) {
  return props.theme.dormifyLightGrey;
});